import { all, takeEvery, call, put, select } from 'redux-saga/effects';
import { defineMessages } from 'react-intl';
import { reset } from 'redux-form';
import { fetchEntity } from '@classpass/saga-tools';

import { DYNAMIC_PRICING_CONTROLS_FORM_NAME } from 'constants/logic';
import { IA_KEY } from 'helpers/ia-logic';
import { makePath } from 'helpers/link-generation';
import { selectActiveVenueId, selectIaLogic } from 'selectors/general';
import { dynamicPricingControls, venueEnabledClasses } from 'store/saga/entities/bound';
import { ACTIVE_VENUE_CHANGED } from 'features/App';
import { createInfoBanner, createErrorBanner } from 'components/Banner';

export const messages = defineMessages({
  success: {
    id: 'dynamic-pricing.saga.success',
    defaultMessage: 'Dynamic Pricing rules set successfully.',
  },
  error: {
    id: 'dynamic-pricing.saga.error',
    defaultMessage: 'There was an error setting Dynamic Pricing rules.',
  },
});

export const SAVE_DYNAMIC_PRICING_CONTROLS = 'SAVE_DYNAMIC_PRICING_CONTROLS';

export const saveDynamicPricingControls = (controls, initialControls) => ({
  type: SAVE_DYNAMIC_PRICING_CONTROLS,
  controls,
  initialControls,
});

export function* handleActiveVenueChange(client, action) {
  const { venueId } = action;

  yield all([
    put(reset(DYNAMIC_PRICING_CONTROLS_FORM_NAME)),
    call(client.navigate, makePath.editVenueDynamicPricing(venueId)),
  ]);
}

export function* doSaveDynamicPricingControls(client, action) {
  try {
    const { controls, initialControls } = action;
    const venueId = yield select(selectActiveVenueId);
    yield call(fetchEntity, dynamicPricingControls, [client, venueId, controls, initialControls]);
    yield put(createInfoBanner(messages.success));
  } catch (error) {
    put(createErrorBanner(messages.error));
  }
}

export function* handleDynamicPricingRouteEnter(client) {
  const venueId = yield select(selectActiveVenueId);
  const { userHasAccess, featureIsSupported } = yield select(selectIaLogic, IA_KEY.MANAGE_DYNAMIC_PRICING, venueId);

  if (!userHasAccess || !featureIsSupported) return;

  yield all([
    call(fetchEntity, dynamicPricingControls, [client, venueId]),
    call(fetchEntity, venueEnabledClasses, [client, venueId]),
  ]);
}

export function* watchDynamicPricingPage(client) {
  yield takeEvery(ACTIVE_VENUE_CHANGED, handleActiveVenueChange, client);
  yield takeEvery(SAVE_DYNAMIC_PRICING_CONTROLS, doSaveDynamicPricingControls, client);
}
